import React, { useState, useEffect } from "react";
import { ApiGetClients, ApiGetClientEntities, ApiGetStarRatingReport, ApiGetClientDbName } from "../../../apiService/Core/Apicall.tsx";
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Button,
    Box, Stack,
    FormControl,
    Autocomplete,
    IconButton,
    TextField,
    Typography,
} from "@mui/material";
import { format } from "date-fns";
import "react-datepicker/dist/react-datepicker.css";
import { ChevronLeftIcon, ChevronRightIcon } from "lucide-react";
interface ClientType {
    clientId: number;
    clientName: string;
}
interface ClientEntity {
    clientEntityId: number;
    entityName: string;
}
const StarRatingReport: React.FC = () => {
    const [clients, setClients] = useState<any>([]);
    const [clientEntities, setClientEntities] = useState<ClientEntity[]>([]);
    const [selectedEntityId, setSelectedEntityId] = useState<number | null>(null);
    const [selectedClient, setSelectedClient] = useState<ClientType | null>(null);
    const [currentDate, setCurrentDate] = useState(new Date());
    const [reportMonth, setReportMonth] = useState<number>(currentDate.getMonth() + 1);
    const [reportYear, setReportYear] = useState<number>(currentDate.getFullYear());
    const [reportData, setReportData] = useState<any[]>([]);
    const [clientGroups, setClientGroups] = useState<any[]>([]);
    const [selectedGroupDbName, setSelectedGroupDbName] = useState<any>(null);


    const handlePrevMonth = () => {
        setCurrentDate((prevDate) => {
            const newDate = new Date(prevDate.getFullYear(), prevDate.getMonth() - 1, 1);
            setReportMonth(newDate.getMonth() + 1);
            setReportYear(newDate.getFullYear());
            return newDate;
        });
    };

    const handleNextMonth = () => {
        setCurrentDate((prevDate) => {
            const newDate = new Date(prevDate.getFullYear(), prevDate.getMonth() + 1, 1);
            setReportMonth(newDate.getMonth() + 1);
            setReportYear(newDate.getFullYear());
            return newDate;
        });
    };

    const handleDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newDate = new Date(event.target.value + "-01");
        setCurrentDate(newDate);
        setReportMonth(newDate.getMonth() + 1);
        setReportYear(newDate.getFullYear());
    };

    useEffect(() => {
        const getclientgroupName = async () => {

            try {
                const res = await ApiGetClientDbName()
                setClientGroups(res.data)
                setSelectedGroupDbName(res.data.find(item => item.clientGroupName === "MM"))

            } catch (error) {
                alert(error)
            }
        }
        getclientgroupName()
    }, [])

    useEffect(() => {
        const getclients = async () => {
            if (selectedGroupDbName) {

                try {
                    const query = `?status=active&clientGroup=${selectedGroupDbName.clientGroupName}`;
                    const res = await ApiGetClients(query)
                    const mappedClients = res.data.map((client: any) => ({
                        clientId: client.ClientID,
                        clientName: client.ClientName,
                    }));

                    setClients(mappedClients);
                    //   setSelectedClient(mappedClients[0])

                } catch (error) {
                    alert(error)
                }
            }
        }
        getclients()
    }, [selectedGroupDbName])

    useEffect(() => {
        const getcliententities = async () => {
            if (selectedClient) {
                const data = `?clientId=${selectedClient.clientId}`
                try {
                    const res = await ApiGetClientEntities(data)
                    setClientEntities(res.data)
                    //   setSelectedEntityId(res.data[0].clientEntityId)
                } catch (error) {
                    alert(error)
                }
            }
        }
        getcliententities()
    }, [selectedClient])

    const handleClientChange = (event: any, value: ClientType | null) => {
        setSelectedClient(value);
        setClientEntities([]);
        setSelectedEntityId(null);
        setReportData([]);

    };
    useEffect(() => {
        if (selectedEntityId) {
            getstarratingreport()
        }
    }, [selectedEntityId, reportMonth, reportYear]);

    const getstarratingreport = async () => {
        setReportData([])
        if (selectedEntityId && reportMonth && reportYear) {
            try {
                const data = `?reportMonth=${reportMonth}&reportYear=${reportYear}&clientEntityId=${selectedEntityId}`
                const res = await ApiGetStarRatingReport(data)
                setReportData(res.data)
            } catch (error) {
                console.log(error)
            }
        }
    }
    const uniqueCategories = Array.from(
        new Set(reportData.map((item) => item.starRatingDesc))
    );

    const groupedByVenue = reportData.reduce((acc: any, item: any) => {
        if (!acc[item.venueName]) {
            acc[item.venueName] = {
                venueName: item.venueName,
                scores: {},
            };
        }
        acc[item.venueName].scores[item.starRatingDesc] = item.starRatingScore;
        return acc;
    }, {});
    const venueMap = new Map<string, number[]>();

    reportData.forEach((item) => {
        const venueId = item.venueId;
        const score = parseFloat(item.starRatingScore);

        if (!isNaN(score)) {
            if (!venueMap.has(venueId)) {
                venueMap.set(venueId, []);
            }
            venueMap.get(venueId)!.push(score);
        }
    });

    const venueAverages: number[] = [];

    venueMap.forEach((scores, venueId) => {
        const sum = scores.reduce((a, b) => a + b, 0);
        const avg = sum / scores.length;
        venueAverages.push(avg);
    });
    const overallAverage = venueAverages.length
        ? (venueAverages.reduce((a, b) => a + b, 0) / venueAverages.length).toFixed(2)
        : "0";
    return (
        <Box sx={{ p: 4 }} style={{ background: "white" }}>
            <Box sx={{ width: "100%" }}>

                <Box sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginRight: "0px",
                }}>
                    <Typography variant="h3" className="common-manage-h1" sx={{
                        textAlign: "center",
                        flexGrow: 1,
                        // ml: "200px"
                    }}>
                        Star Rating
                    </Typography>
                    <Box sx={{
                        height: "40px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                    }}>

                    </Box>
                </Box>
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginBottom: "-70px",
                        marginTop: "23px",
                    }}
                >
                    <Stack direction="row" spacing={2}>
                        <FormControl size="small" sx={{ width: 180, mb: 0 }}>
                            <Autocomplete
                                disablePortal
                                id="group-autocomplete"
                                options={clientGroups}
                                value={selectedGroupDbName}
                                getOptionLabel={(option: any) => option.clientGroupName || ""}
                                isOptionEqualToValue={(option: any, value: any) => option.clientGroupDBName === value.clientGroupDBName}
                                onChange={(event, value) => {
                                    setSelectedGroupDbName(value);
                                    setClients([]);
                                    setSelectedClient(null);
                                    setClientEntities([]);
                                    setSelectedEntityId(null);
                                    setReportData([])
                                }}
                                renderInput={(params) => (
                                    <TextField {...params} label="Select Client Group" />
                                )}
                                size="small"
                            />
                        </FormControl>
                        <FormControl size="small" sx={{ width: 180 }}>
                            <Autocomplete
                                disablePortal
                                id="beacon-autocomplete"
                                options={clients}
                                value={selectedClient}
                                getOptionLabel={(option: ClientType) => option.clientName}
                                isOptionEqualToValue={(option, value) => option.clientId === value.clientId}
                                onChange={handleClientChange}
                                renderInput={(params) => (
                                    <TextField {...params} label="Select Client" />
                                )}
                                size="small"
                            />
                        </FormControl>
                        <FormControl size="small" sx={{ width: 185 }}>
                            <Autocomplete
                                disablePortal
                                id="mm-autocomplete"
                                options={clientEntities}

                                getOptionLabel={(option: any) => option.entityName}
                                value={clientEntities.find((entity) => entity.clientEntityId === selectedEntityId) || null}
                                onChange={(event: any, value: ClientEntity | null) => {
                                    setSelectedEntityId(value?.clientEntityId || null);
                                    setReportData([]);
                                }}
                                renderInput={(params) => (
                                    <TextField {...params} label="Select Business" />
                                )}
                                size="small"
                            />
                        </FormControl>
                    </Stack>
                    <Stack direction="row" spacing={2}>
                        <Button variant="contained" sx={{ backgroundColor: "#75724C", borderRadius: "8px", px: 3, "&:hover": { backgroundColor: "#5a522c" } }}>
                            DOWNLOAD AS XLSX
                        </Button>
                        <Button variant="contained" sx={{ backgroundColor: "#75724C", borderRadius: "8px", px: 3, "&:hover": { backgroundColor: "#5a522c" } }}>
                            DOWNLOAD AS PDF
                        </Button>
                    </Stack>
                </Box>
            </Box>
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginTop: "20px"
                }}
            >
                <IconButton onClick={handlePrevMonth}>
                    <ChevronLeftIcon />
                </IconButton>
                <Box sx={{ display: "flex", alignItems: "center", mx: 2 }}>
                    <input
                        type="month"
                        onChange={handleDateChange}
                        value={format(currentDate, "yyyy-MM")}
                        className="primary-color"
                        style={{
                            border: "none",
                            background: "none",
                            fontSize: "1.25rem",
                            fontWeight: "bold",
                            cursor: "pointer",
                            fontFamily: "inherit",
                        }}
                    />
                </Box>
                <IconButton onClick={handleNextMonth}>
                    <ChevronRightIcon />
                </IconButton>
            </Box>
            {selectedEntityId && selectedGroupDbName && (
                <>
                    <Box
                        sx={{
                            backgroundColor: "#eaf4d3",
                            border: "2px solid #6b773c",
                            borderRadius: "8px",
                            padding: "20px",
                            height: "70px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            width: "100%",
                            marginTop: "20px",
                        }}
                    >

                        <Typography variant="h5" fontWeight="bold" color="#424d21">
                            Overall Score: {overallAverage}/5
                        </Typography>
                    </Box>
                    <Box
                        sx={{
                            width: "100%",
                            borderRadius: "8px",
                            border: "2px solid #6b773c",
                            overflow: "hidden",
                            mt: 2,
                            backgroundColor: "#d6e4bc",
                            padding: "20px",
                        }}
                    >
                        <Typography
                            variant="h5"
                            fontWeight="bold"
                            color="black"
                            textAlign="center"
                            sx={{ padding: "15px", borderBottom: "2px solid white" }}
                        >
                            Venue Comparison Report
                        </Typography>

                        <Box
                            sx={{
                                border: "2px solid #6b773c",
                                borderRadius: "8px",
                                backgroundColor: "white",
                                mt: 2,
                                overflow: "hidden",
                            }}
                        >
                            <Table sx={{ width: "100%", tableLayout: "fixed", borderCollapse: "collapse" }}>
                                <TableHead>
                                    <TableRow className="table-row-background">
                                        <TableCell sx={{ width: "20%", color: "#fff", fontWeight: "bold", textAlign: "left" }}>
                                            Venue Name
                                        </TableCell>
                                        {uniqueCategories.map((category) => (
                                            <TableCell
                                                key={category}
                                                sx={{ color: "#fff", fontWeight: "bold", textAlign: "center" }}
                                            >
                                                {category}
                                            </TableCell>
                                        ))}
                                        <TableCell sx={{ color: "#fff", fontWeight: "bold", textAlign: "end" }}>
                                            Average Score
                                        </TableCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {Object.values(groupedByVenue).map((venue: any, idx: number) => {
                                        const validScores = uniqueCategories
                                            .map((cat) => parseFloat(venue.scores[cat]))
                                            .filter((score) => !isNaN(score));

                                        const total = validScores.reduce((a, b) => a + b, 0);
                                        const average = validScores.length ? (total / validScores.length).toFixed(2) : "N/A";
                                        return (
                                            <TableRow key={idx}>
                                                <TableCell sx={{ fontWeight: "bold", textAlign: "left" }}>{venue.venueName}</TableCell>
                                                {uniqueCategories.map((cat, idx) => (
                                                    <TableCell
                                                        key={idx}
                                                        sx={{
                                                            textAlign: "center",
                                                            backgroundColor:
                                                                parseFloat(venue.scores[cat]) <= 3 ? "#e0e0e0" : "transparent",
                                                        }}
                                                    >
                                                        {venue.scores[cat] !== undefined ? venue.scores[cat] : "N/A"}
                                                    </TableCell>
                                                ))}
                                                <TableCell sx={{ fontWeight: "bold", textAlign: "end", borderLeft: "3px solid gray", backgroundColor: parseFloat(average) <= 3 ? "#e0e0e0" : "transparent", }}>
                                                    {average}
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}
                                </TableBody>
                            </Table>
                        </Box>
                    </Box>
                    <Box
                        sx={{
                            width: "100%",
                            borderRadius: "8px",
                            border: "2px solid #6b773c",
                            overflow: "hidden",
                            mt: 2,
                            backgroundColor: "#d6e4bc",
                            padding: "20px",
                        }}
                    >
                        <Typography
                            variant="h5"
                            fontWeight="bold"
                            color="black"
                            textAlign="center"
                            sx={{ padding: "15px", borderBottom: "2px solid white" }}
                        >
                            Category Report
                        </Typography>
                        <Box
                            sx={{
                                display: "grid",
                                gridTemplateColumns: "repeat(3, 1fr)",
                                gap: 2,
                                mt: 2,
                                alignItems: "start",
                            }}
                        >
                            {uniqueCategories.map((category) => {
                                const categoryData = reportData.filter((item) => item.starRatingDesc === category);

                                return (
                                    <Box
                                        key={category}
                                        sx={{
                                            border: "2px solid #6b773c",
                                            borderRadius: "8px",
                                            backgroundColor: "white",
                                            overflow: "hidden",

                                        }}
                                    >
                                        <Typography
                                            fontWeight="bold"
                                            color="white"
                                            className="table-row-background"
                                            sx={{
                                                padding: "15px",
                                                textAlign: "center",
                                                fontSize: '15px'
                                            }}
                                        >
                                            {category}
                                        </Typography>

                                        <Table sx={{ width: "100%", tableLayout: "fixed", borderCollapse: "collapse" }}>
                                            <TableBody>
                                                {categoryData.map((data: any, index: number) => (
                                                    <TableRow key={index}>
                                                        <TableCell
                                                            sx={{
                                                                width: "85%",
                                                                textAlign: "left",
                                                                padding: "10px",
                                                                fontWeight: "bold",
                                                                borderRight: "2px solid #4d5a2c",
                                                                color: "black",
                                                            }}
                                                        >
                                                            {data.venueName}
                                                        </TableCell>
                                                        <TableCell
                                                            sx={{
                                                                textAlign: "center",
                                                                padding: "10px",
                                                                fontWeight: "bold",
                                                                color: "black",
                                                                backgroundColor: (parseFloat(data.starRatingScore) <= 3 ? "#e0e0e0" : "transparent"),
                                                            }}
                                                        >
                                                            {data.starRatingScore}
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </Box>
                                );
                            })}
                        </Box>
                    </Box>
                    <Box
                        sx={{
                            width: "100%",
                            borderRadius: "8px",
                            border: "2px solid #6b773c",
                            overflow: "hidden",
                            mt: 2,
                            backgroundColor: "#d6e4bc",
                            padding: "20px",
                        }}
                    >
                        <Typography
                            variant="h5"
                            fontWeight="bold"
                            color="black"
                            textAlign="center"
                            sx={{ padding: "15px", borderBottom: "2px solid white" }}
                        >
                            Venue Report
                        </Typography>
                        <Box
                            sx={{
                                display: "grid",
                                gridTemplateColumns: "repeat(3, 1fr)",
                                gap: 2,
                                mt: 2,
                                alignItems: "start",
                            }}
                        >
                            {Array.from(new Set(reportData.map((item) => item.venueName))).map((venue) => {
                                const venueData = reportData.filter((item) => item.venueName === venue);

                                return (
                                    <Box
                                        key={venue}
                                        sx={{
                                            border: "2px solid #6b773c",
                                            borderRadius: "8px",
                                            backgroundColor: "white",
                                            overflow: "hidden",
                                        }}
                                    >
                                        <Typography
                                            fontWeight="bold"
                                            color="white"
                                            className="table-row-background"
                                            sx={{
                                                padding: "15px",
                                                textAlign: "center",
                                                fontSize: '15px'
                                            }}
                                        >
                                            {venue}
                                        </Typography>

                                        <Table sx={{ width: "100%", tableLayout: "fixed", borderCollapse: "collapse" }}>
                                            <TableBody>
                                                {venueData.map((data: any, index: number) => (
                                                    <TableRow key={index}>
                                                        <TableCell
                                                            sx={{
                                                                width: "85%",
                                                                textAlign: "left",
                                                                padding: "10px",
                                                                fontWeight: "bold",
                                                                borderRight: "2px solid #4d5a2c",
                                                                color: "black",
                                                            }}
                                                        >
                                                            {data.starRatingDesc}
                                                        </TableCell>
                                                        <TableCell
                                                            sx={{
                                                                textAlign: "center",
                                                                padding: "10px",
                                                                fontWeight: "bold",
                                                                color: "black",
                                                                backgroundColor: (parseFloat(data.starRatingScore) <= 3 ? "#e0e0e0" : "transparent"),
                                                            }}
                                                        >
                                                            {data.starRatingScore}
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </Box>
                                );
                            })}
                        </Box>
                    </Box>
                </>
            )}
        </Box>
    );
};

export default StarRatingReport;
